<template xmlns:v-hammer="http://www.w3.org/1999/xhtml">
    <div class="window welcome-bg" v-hammer:tap="goToSelection">
        <div class="container ">
            <logo class="logo-img" v-if="!leave"></logo>
            <div v-if="fbBrowser">
                <p class="alert">Please open the app in your default browser (chrome or safari)</p>
                <a target="_blank" href="https://lets-talk-japanese.web.app"></a>
            </div>
            <img src="assets/characters/yuko-loading.png" class="img-responsive_character">
        </div>
    </div>
</template>

<script>
  import Logo from '../components/Logo';
  import RecordMixin from '../mixins/RecordMixin';
  import MobileDetect from 'mobile-detect';

  export default {
    name: 'Welcome',
    components: {
      Logo,
    },
    methods: {
      goToSelection() {
        if (!this.fbBrowser) {
          this.$router.push('/selection');
          this.leave = !this.leave;
        }

      },
    },
    data() {
      return {
        leave: false,
        fbBrowser: false,
      };
    },
    mixins: [RecordMixin],
    created() {
      const detector = new MobileDetect(navigator.userAgent);
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      this.fbBrowser = (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
      this.sendFakeRequest();
    },
  };
</script>

<style lang="scss" scoped>

</style>
